import {
  compose,
  join,
  prepend,
  splitEvery,
  defaultTo,
} from 'ramda'

export default function(phoneCode, phoneNumber) {

  return compose(
    join(' '),
    prepend(phoneCode),
    splitEvery(3),
    defaultTo("")
    )(phoneNumber)
}
